import React from "react";
import { Formik, Field, Form } from "formik";
import l from "components/util/l";
import { Modal } from "seed//helpers";
import IconPicker from "components/util/helpers/IconPicker";
import ProcessPermissionField from "components/util/helpers/ProcessPermissionField";
import RulesField from "components/presentation/chat/model/Model.sub.RulesField.view";

const ProcessForm = ({
  flowId,
  nodeId,
  nodes,
  initialValues = {},
  isDeveloper,
  isEditing,
  isVisibleRules,
  setIsVisibleRules,
  onClickDelete,
  onSubmit
}) => (
  <>
    <div className="card w-100">
      <div className="card-header">
        <h3 className="card-header-title">{!isEditing ? l("Crear proceso%SA244") : l("Editar proceso%SA215")}</h3>
      </div>

      <div className="card-body">
        <div>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}>
            {({ values, setFieldValue }) =>
              <Form>

                <div className="form-group mb-4">
                  <label className="input-label w-100" for="rootName">
                    {l("Nombre del proceso%SA216")}
                    <span className="text-danger ml-1">*</span>
                  </label>
                  <Field
                    type="text"
                    name="rootName"
                    className="form-control"
                    placeholder={l("Ej. Sincronizar información%SA249")}
                    required
                    style={{
                      paddingLeft: "1.2rem",
                      paddingRight: "1.2rem",
                    }}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="input-label w-100" for="icon">
                    {l("Ícono%SA248")} <span className="text-muted">({l("Opcional%GA024")})</span>
                  </label>
                  <IconPicker
                    initialIcon={initialValues?.rootSettings?.icon}
                    onSelectIcon={(icon) => setFieldValue("rootSettings.icon", icon)}
                  />
                </div>

                <div className="form-group mb-4">
                    <label className="input-label w-100" for="rootDescription">
                      {l("Descripción%GA077")} <span className="text-muted">({l("Opcional%GA024")})</span>
                    </label>
                    <Field
                      as="textarea"
                      id="rootDescription"
                      name="rootDescription"
                      rows="3"
                      class="form-control"
                    />
                  </div>



                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-link text-start m-0 p-0 mb-1"
                    data-toggle="collapse"
                    data-target={`#process-form-advance-options`}
                    aria-expanded="false"
                    aria-controls={`process-form-advance-options`}
                  >
                    {l("Opciones avanzadas%SA220")} <i className="fas fa-chevron-down"></i>
                  </button>
                </div>

                <div
                  id={`process-form-advance-options`}
                  className="collapse mt-5"
                >      

                 <label className="dropdown-header text-dark p-0 w-100 mb-3" for="rootDescription">
                    {l("General%GA097")}
                  </label>

                 <div className="form-group mb-4">
                   <Field
                      type="checkbox"
                      name="rootSettings.show_suggestion"
                      className="mr-2"
                    />
                    <label className="form-check-label">
                      {l("Mostrar sugerencia en chat%PA165")}
                    </label>
                   
                  </div>           

                  <label className="dropdown-header text-dark p-0 w-100 mt-6" for="rootDescription">
                    {l("Permisos%SA246")}
                  </label>

                  <ProcessPermissionField
                    flowId={flowId}
                    values={values.rootSettings}
                    setFieldValue={(field, value) => {
                      setFieldValue(`rootSettings.${field}`, value);
                    }}
                  />                 

                  <label className="dropdown-header text-dark p-0 mb-3 w-100 mb-1 mt-6" for="rules">
                    {l("Ejecutar cuando%PA127")}
                  </label>

                  <RulesField
                    flow={{ id: flowId }}
                    name={"rules"}
                    values={values}
                    ruleMode={"EXECUTION"}
                    isDeveloper={isDeveloper}
                    isSingleMode={true}
                    setFieldValue={setFieldValue}
                    nodes={nodes}
                  />

                </div>

                <div className="row">
                  <div className={`col-md-${isEditing ? "8 pr-0" : "12"}`}>
                    <button type="submit" class="btn btn-primary font-weight-bold w-100 mt-3">
                      {isEditing ? l("Guardar%GA023") : l("Siguiente%GA039")}
                    </button>
                  </div>
                  {isEditing && (
                    <div className="col-md-4">
                      <button type="button" class="btn btn-outline-danger w-100 mt-3" onClick={onClickDelete}>{l("Eliminar%GA001")}</button>
                    </div>
                  )}
                </div>

              </Form>}
          </Formik>
        </div>

      </div>
    </div>

    {
      isEditing && isVisibleRules &&
      <Modal
        width="550"
        height="600"
        nodeId={nodeId}
        onClose={() => setIsVisibleRules(false)}
      >
        
      </Modal>
    }

  </>
);

export default ProcessForm;